export const UnitOfMeasureEnum = Object.freeze({
  Imperial: 1,
  Metric: 2,
});
